import { useEffect, useState } from "react";
import {
  DeleteIcon,
  DownArrow,
  IncomingCallIcon,
  InternalCallIcon,
  OutgoingCallIcon,
  PhoneIncomingCallIcon,
  UpArrow,
  UserIcon,
} from "../../../utils/icons/defaultIcons";
import FadeIn from "react-fade-in";
import moment from "moment";
import DurationCounter from "../../../atom/timeDuration";
import { Form } from "react-router-dom";
import FormatMobileNumber from "../../../atom/formatMobileNumber";

function AgentInfoCard(props: any) {
  
  const { page, data } = props;

  const [dropdownSelect, setDropdownSelect] = useState<boolean>(true);

  const [agentInfo, setAgentInfo] = useState<any>([
    {
      key: "call_did",
      value: "",
      title: "Caller ID",
    },
    // {
    //   key: "call_start_time",
    //   value: "",
    //   title: "Start",
    // },
    {
      key: "call_duration",
      value: "",
      title: "Duration",
    },
    // {
    //   value: "",
    //   title: "Call Count",
    // },
    // {
    //   value: "",
    //   title: "Talk Time",
    // },
    // {
    //   value: "",
    //   title: "Avg Talk Time",
    // },
  ]);
  // useEffect(() => {
  //   console.log("dataaaa", data);

  //   const updatedAgentInfo = agentInfo.map((item: any) => {
  //     if (item.key === "call_start_time" && data[item.key] !== "") {
  //       return {
  //         ...item,
  //         value: moment(new Date(data[item.key])).format("LTS"),
  //       };
  //     }

  //     if (item.key === "call_duration") {
  //       return {
  //         ...item,
  //         value:
  //           data.call_start_time !== "" && data.ph_state === "busy" ? (
  //             <DurationCounter startTime={data.call_start_time} />
  //           ) : (
  //             ""
  //           ),
  //       };
  //     }

  //     return {
  //       ...item,
  //       value: data[item.key] !== undefined ? data[item.key] : item.value,
  //     };
  //   });

  //   setAgentInfo(updatedAgentInfo);
  // }, [data]);
  // const dropdownselect = () => {
  //   if (data?.ph_state === "busy") setDropdownSelect(!dropdownSelect);
  // };
  // useEffect(() => {
  //   console.log("data?.call_start_time", data?.call_start_time);
  //   if (data?.call_start_time === "") {
  //     setDropdownSelect(false);
  //   } else {
  //     setDropdownSelect(true);
  //   }
  // }, [data]);

  return (
    <div
      data-testid="agentInfoCard"
      className={`${
        page === "main" ? "relative" : ""
      } shadow hover:shadow-xl h-fit ${!dropdownSelect && "hover:scale-y-105"}`}
    >
      {/* agent box */}

      {/* top bar */}
      <div
        className={`h-[67px] ${
          !data?.is_logged_in
            ? "bg-[#EBEBEB80]"
            : data?.ph_state === "busy"
            ? "bg-[#D14D41]"
            : "bg-[#879A39]"
        } rounded-lg mt-4 group`}
      >
        <div className="flex justify-between p-3 px-6">
          <div className="flex gap-4 w-full items-center">
            {/* Icon and Extension */}
            <div className="flex flex-col items-center justify-center">
              <UserIcon />
              <p>{data?.extension}</p>
            </div>

            {/* Name and Status */}
            <div className="flex flex-1 items-center justify-between min-w-0">
              {/* Name (with ellipsis) */}
              <div className="truncate text-[18px] min-w-0">
                {data?.first_name} {data?.last_name}
              </div>

              {/* Status Box */}
              <div className="flex items-center flex-shrink-0">
                <div className="flex items-center gap-x-1 px-2 py-1 rounded-lg bg-[#FBFBFF] max-w-[120px]">
                  <div
                    className={`rounded-full h-[7px] w-[7px] ${
                      !data?.is_logged_in
                        ? "bg-[#7f7b7b]"
                        : data?.ph_state === "busy"
                        ? "bg-[#D14D41]"
                        : "bg-[#879A39]"
                    }`}
                  ></div>
                  <div
                    className={`truncate text-[16px] ${
                      !data?.is_logged_in
                        ? "text-[#7f7b7b]"
                        : data?.ph_state === "busy"
                        ? "text-[#D14D41]"
                        : "text-[#879A39]"
                    }`}
                  >
                    {!data?.is_logged_in
                      ? "Logged Out"
                      : data?.ph_state === "busy"
                      ? "Busy"
                      : "Available"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  */}

      {dropdownSelect && (
        <div
          className={`h-auto w-full bg-[#E6F9F4] overflow-visible rounded-lg  
           z-[2]`}
        >
          <FadeIn>
            <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-2 py-1 space-y-4  justify-items-center ">
              {agentInfo?.map((node: any, index: number) => {
                return (
                  <div key={index} className="mt-4 px-1">
                    <div className=" text-[18px] font-bold justify-center items-center flex">
                      {/* {node.key === "call_did" && (
                        <div className="mt-0.5 ">
                          {data?.call_direction === "inbound" ? (
                            <IncomingCallIcon />
                          ) : data?.call_direction === "outbound" ? (
                            <OutgoingCallIcon />
                          ) : data?.call_direction === "internal" ? (
                            <InternalCallIcon />
                          ) : null}
                        </div>
                      )} */}
                      {data[node.key] === "" ? (
                        "--"
                      ) : (
                        <span>
                          {node.key === "call_did" ? (
                            <FormatMobileNumber number={data[node.key]} />
                          ) : node.key === "call_start_time" ? (
                            data[node.key] !== "" ? (
                              moment(new Date(data[node.key])).format("hh:mm A")
                            ) : (
                              data[node.key]
                            )
                          ) : node.key === "call_duration" ? (
                            data?.call_start_time !== "" ? (
                              <DurationCounter
                                startTime={data.call_start_time}
                              />
                            ) : (
                              "--"
                            )
                          ) : (
                            data[node.key]
                          )}
                        </span>
                      )}
                    </div>
                    <p className=" text-center font-normal text-[#595754]">
                      {node.key === "call_did" &&
                        (data?.call_direction !== "" ? (
                          <div className="flex justify-center items-center">
                            {data?.call_direction === "inbound" ? (
                              <IncomingCallIcon />
                            ) : data?.call_direction === "outbound" ? (
                              <OutgoingCallIcon />
                            ) : data?.call_direction === "internal" ? (
                              <InternalCallIcon />
                            ) : null}

                            {data?.call_direction.charAt(0).toUpperCase() +
                              data?.call_direction.slice(1)}
                          </div>
                        ) : (
                          "Caller ID"
                        ))}

                      {node.key !== "call_did" && node.title}
                    </p>
                  </div>
                );
              })}
            </div>
          </FadeIn>
        </div>
      )}
    </div>
  );
}

export default AgentInfoCard;
